import { render, staticRenderFns } from "./ConventionalTibet.vue?vue&type=template&id=2093b88e&scoped=true&"
import script from "./ConventionalTibet.vue?vue&type=script&lang=js&"
export * from "./ConventionalTibet.vue?vue&type=script&lang=js&"
import style0 from "./ConventionalTibet.vue?vue&type=style&index=0&id=2093b88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093b88e",
  null
  
)

export default component.exports